import SectionHeading from "../components/SectionHeading";
import { MaskedLines, FadeIn, Reveal } from "../components/motion/Reveal";

const SECTIONS = [
  ["Shipping Areas", "We ship worldwide to 40+ countries across North America, Europe, the Middle East, Oceania, and Asia. Both port-to-port and door-to-door options are available."],
  ["Processing Time", "In-stock and repeat orders are processed within 2–3 business days of payment confirmation."],
  ["Production Time", "Made-to-order production runs 20–35 days depending on product, customization, and order volume. Your quotation always includes a confirmed production window."],
  ["Shipping Methods", "Air freight (5–10 days), sea freight LCL/FCL (20–45 days), and express courier (DHL/FedEx/UPS, 3–7 days) for samples and small orders."],
  ["Estimated Delivery", "Total lead time = production time + transit time. Your account manager shares a detailed timeline at order confirmation."],
  ["Shipping Charges", "Quoted per order based on volume, weight, destination, and method. We work with forwarders to secure competitive rates and pass them through at cost."],
  ["Tracking", "Every shipment includes tracking. Sea freight orders receive BL copies and container tracking; air and express receive live tracking links."],
  ["Customs & Duties", "Import duties and taxes are the buyer's responsibility unless shipped DDP. We provide complete export documentation: commercial invoice, packing list, and certificate of origin."],
  ["Commercial Payment & Dispatch Terms", "All production export orders follow our 50% advance deposit on order confirmation / PI sign-off and 50% balance payment upon pre-shipment QC inspection approval. Accepted methods include Bank Wire (T/T), Western Union, MoneyGram, Letter of Credit (L/C), Wise, and Payoneer."],
  ["International Shipping Information", "We ship FOB, CIF, and DDP terms. Our team coordinates with your forwarder or assigns one of ours — whichever you prefer."],
];

const ShippingPolicy = () => (
  <div data-testid="shipping-policy-page">
    <section className="border-b border-black/10 bg-white">
      <div className="mx-auto max-w-[1400px] px-5 pb-16 pt-16 md:pt-24 lg:px-10">
        <FadeIn>
          <p className="mono-caption mb-8 text-neutral-500">Policy — Last updated January 2026</p>
        </FadeIn>
        <h1 className="font-display text-4xl font-semibold leading-[1.02] tracking-tighter sm:text-5xl lg:text-6xl">
          <MaskedLines lines={["SHIPPING", <>POLICY<span className="text-brand-red">.</span></>]} />
        </h1>
      </div>
    </section>
    <section className="mx-auto max-w-[1100px] px-5 py-20 md:py-28 lg:px-10">
      <SectionHeading number="01" title="How We Ship" />
      <div className="divide-y divide-black/10 border-y border-black/10">
        {SECTIONS.map(([t, d], i) => (
          <Reveal key={t} delay={i * 0.03}>
            <div className="grid gap-2 py-7 sm:grid-cols-12" data-testid={`shipping-section-${i}`}>
              <span className="font-mono text-sm text-brand-red sm:col-span-1">{String(i + 1).padStart(2, "0")}</span>
              <h3 className="font-display text-xl font-medium tracking-tight sm:col-span-4">{t}</h3>
              <p className="text-sm leading-relaxed text-neutral-500 sm:col-span-7">{d}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  </div>
);

export default ShippingPolicy;
